import {ClassName, DefaultChildren} from '#/utils/utils';
import {FunctionComponent} from 'react';

export const HomeSection: FunctionComponent<DefaultChildren & ClassName> = ({children, className}) => {
  return <section className={className}>{children}</section>;
};

export const HomeSectionTitle: FunctionComponent<DefaultChildren & ClassName> = ({children, className}) => (
  <h2 className={`px-5 md:px-10 @screen2xl/home:!pl-homeMaxScreen2xl text-2xl text-blue-600 font-bold ${className}`}>
    {children}
  </h2>
);

export const HomeSectionSubtitle: FunctionComponent<DefaultChildren & ClassName> = ({children, className}) => (
  <h2
    className={`px-5 md:px-10 @screen2xl/home:!pl-homeMaxScreen2xl text-base text-gray-400 font-semibold mb-6 ${className}`}
  >
    {children}
  </h2>
);

export const HomeSectionHorizontalScroll: FunctionComponent<DefaultChildren & ClassName> = ({children, className}) => (
  <h2 className={`w-full overflow-x-scroll relative ${className}`}>{children}</h2>
);

export const HomeSectionHorizontalScrollContent: FunctionComponent<DefaultChildren & ClassName> = ({
  children,
  className,
}) => <div className={`px-5 md:px-10 @screen2xl/home:!pl-homeMaxScreen2xl ${className}`}>{children}</div>;
